import {
  FulfillmentsOverTimeRequestSchema,
  FulfillmentsOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getFulfillmentsOverTime = {
  name: "getFulfillmentsOverTime" as const,
  input: FulfillmentsOverTimeRequestSchema,
  output: FulfillmentsOverTimeResponseSchema,
};
